import { takeEvery } from "redux-saga/effects";
import {
  checkEnrollmentAction,
  enrollAction,
  getTotalEnrollInstructorAction,
  myTotalEnrollmentAction,
} from "./slices";
import {
  checkEnrollmentWorker,
  enrollWorker,
  getTotalEnrollInstructorWorker,
} from "./workers";
import { myTotalEnrollmentWorker } from "./workers/myTotalEnrollment";

const enrollmentWatcher = [
  takeEvery(checkEnrollmentAction, checkEnrollmentWorker),
  takeEvery(enrollAction, enrollWorker),
  takeEvery(myTotalEnrollmentAction, myTotalEnrollmentWorker),
  takeEvery(getTotalEnrollInstructorAction, getTotalEnrollInstructorWorker),
];

export default enrollmentWatcher;
